import { useState, useEffect } from "react";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";
import { useFeaturesReady } from "../../../context/featuresReady/FeaturesReadyContext";
import { getFeature } from "../../../utils/features";

const useShowReviewSummary = (reviewsSummary) => {
  const {
    features: { reviewSummaryEnabled },
  } = useRuntimeConstants();
  const { areFeaturesReady } = useFeaturesReady();
  const [isFeatureFlagEnabled, setIsFeatureFlagEnabled] = useState(false);

  useEffect(() => {
    if (!reviewSummaryEnabled || !areFeaturesReady || reviewsSummary === null)
      return;

    setIsFeatureFlagEnabled(getFeature("pdp-review-summary").isEnabled());
  }, [reviewSummaryEnabled, areFeaturesReady, reviewsSummary]);

  return (
    reviewSummaryEnabled && isFeatureFlagEnabled && reviewsSummary !== null
  );
};

export default useShowReviewSummary;
